export const APP_NAME = 'MediInsight AI';
export const APP_TAGLINE = 'AI-guided healthcare support for diagnostics, wellness, and care coordination.';
export const DEFAULT_PAGE_DESCRIPTION =
  'MediInsight AI delivers imaging analysis, personalized wellness plans, appointment workflows, and mental wellness guidance in one healthcare platform.';

const DEFAULT_API_BASE_URL = 'http://localhost:3001/api';

export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL?.replace(/\/$/, '') || DEFAULT_API_BASE_URL;

export function buildApiUrl(path: string) {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${API_BASE_URL}${normalizedPath}`;
}
